<template>
    <Fieldset :legend="translate('presentation', 'ucfirst')"
      class="w-full px-5 pb-5 mt-10 md:mt-7 bg-white rounded-lg shadow-md border border-color-iron">
     <Skeleton v-if="isLoading && presentation" height="1.5rem"></Skeleton>     
      <span v-else-if="!isLoading && JSON.stringify(presentation) != '{}'">
        <p>
          {{ presentation.presentation_text }}
        </p>
      </span>
      <span v-else>
        <p>
          {{ translate('no presentation', 'ucfirst') }}
        </p>
      </span>
    </Fieldset>  
</template>

<script setup>
import { ref, onMounted, onUpdated } from 'vue'
import Fieldset from "primevue/fieldset";
import Skeleton from 'primevue/skeleton';
import { translate } from "@/composables/translate";


const props = defineProps({
  presentations: {
    type: Array,
    required: true,
    default: () => []
  }
});

let isLoading = ref(false)
let presentation = ref({})


onUpdated(() => {
  isLoading.value = false
  if (props.presentations.length > 0) {
    presentation.value = props.presentations[0]
  }
})

onMounted(() => {
  isLoading.value = true
});
</script>

<style scoped></style>